/**
 *
 * @module userActivityEvent
 *
 */

import Check from 'check-types';
import Services from './../services/entry';

const InvalidArgumentException = Services.Exception.InvalidArgumentException;

const {
    nonEmptyString
} = Check.assert;

/**
 *
 * @interface UserActivityEvent
 * @desc creates a key for referencing UserActivity-related events
 *
 */
export default class UserActivityEvent {

    /**
     *
     * @param {String} eventUrn
     * @throws {InvalidArgumentException}
     *
     */
    constructor(eventUrn) {

        const errorMessage = {
            ctor: 'UserActivityEvent(eventUrn)',
            eventUrn() {
                return `${this.ctor} eventUrn should be a String with length`;
            }
        };

        nonEmptyString(eventUrn, errorMessage.eventUrn, InvalidArgumentException);

        /**
         *
         * @access private
         * @type {String}
         * @note stores the event urn referenced from `SDK.Services.Internal.Dust.DustUrnReference` or a custom urn
         *
         * @example new UserActivityEvent(SDK.Services.Internal.Dust.DustUrnReference.userActivity.glimpse.appLoaded)
         * @example new UserActivityEvent('urn:dss:something:custom') // when you need something custom
         *
         */
        this.eventUrn = eventUrn;

    }

}



// WEBPACK FOOTER //
// ./src/userActivity/userActivityEvent.js